var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V2---No-Accounts-Open",
    transform: "translate(-314.000000, -29.000000)",
    fill: "#DAE5EF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top-Nav",
    transform: "translate(-33.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.307675,51.6152853 C352.075555,51.6152853 347,46.5397448 347,40.3076427 C347,34.0755407 352.075555,29 358.307675,29 C364.539794,29 369.615349,34.0755406 369.615349,40.3076427 C369.615349,42.8267345 368.780938,45.2233464 367.273165,47.1832027 L373.545573,53.4557019 C373.931653,53.8263755 374.087177,54.3768079 373.952163,54.8947148 C373.81715,55.4126217 373.412696,55.817074 372.894788,55.9520872 C372.376879,56.0871005 371.826445,55.9315774 371.461265,55.5511058 L365.183252,49.2731095 C363.22339,50.7808769 360.826772,51.6152853 358.307675,51.6152853 Z M358.307675,31.955812 C353.682136,31.955812 349.95582,35.6821174 349.95582,40.3076427 C349.95582,44.9331682 353.682136,48.6594733 358.307675,48.6594733 C362.933213,48.6594733 366.659529,44.9331684 366.659529,40.3076427 C366.659529,35.6821172 362.933213,31.955812 358.307675,31.955812 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2ee17ae44bdbcc5216f19e7de8ce3a40.svg";
export { ForwardRef as ReactComponent };